/** Created by azhou on 2019/2/22.*/
<template>
  <div>
    <div v-if="!$route.path.includes('info-manage') || userLoginMessage.type == 99">
      <left-text-border class="mb-3"
                      leftText="采购商名称"
                      placeholder="请填写您的单位名称"
                      required
                      inputId="inputTitle"
                      :disabled="disabledStoreName"
                      v-model="BasicInfo.title"/>
      <select-city class="mb-3"
                  leftText="省市区"
                  required
                  @getCityInfo="getCityInfo"
                  :provinceId="BasicInfo.province*1"
                  :cityId="BasicInfo.city*1"
                  :districtId="BasicInfo.district*1"/>
      <left-text-border class="mb-3"
                        leftText="详细地址"
                        placeholder="请输入详细地址"
                        required
                        v-model="BasicInfo.address"
                        />
    </div>
    <left-text-border class="mb-3"
                      leftText="办公电话"
                      v-model="BasicInfo.travel_tel"
                      placeholder="例如：0571-123456"
                      required/>
    <!-- <left-text-border class="mb-3"
                      leftText="传真号码"
                      v-model="BasicInfo.travel_fax"
                      placeholder="例如：0571-123456"/> -->
    <!-- <div class="d-start-start" v-if="showCertpic">
      <left-text leftText="营业执照"/>
      <upload-image @fileChange="(imgs)=>{this.certpic = imgs[0];}"
                    :existImgs="BasicInfo.certpic" :maxLength="1" editMode/>
    </div> -->
    <el-button @click="submitForm" class="mt-4 w-25 btn-login">保存信息</el-button>
  </div>
</template>

<script>
  import { mapState,mapGetters,mapActions} from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'

  export default {
    name: 'TRegBasic',
    computed: {
      ...mapState(['StoreBasicInfo','newMessageInform','userLoginMessage']),
      ...mapGetters(['isGroup','storeInfo','userInfo',"isAdmin"]),
      //当用户为单门店且在注册步骤时才显示上传营业执照,集团用户添加门店时才显示
      showCertpic() {
        if (this.isGroup) {
          return true;
        } else return this.StoreBasicInfo.verify !== 1;
      },
      //禁用修改门店名称
      disabledStoreName() {
        return this.userInfo.type !== 99 && this.StoreBasicInfo.verify === 1;
      }
    },
    data () {
      return {
        BasicInfo: {},
        certpic:'',            //base64格式营业执照，还未上传时不挂载到BasicInfo中
      }
    },
    watch: {
      StoreBasicInfo (newVal) {
        this.BasicInfo = newVal;
        this.certpic = this.BasicInfo.certpic;
      },
      //认证通过进行页面跳转
      newMessageInform (newVal) {
        if (newVal.verify == 1) {      //采购商认证通过
         this.$router.push('/userCenter')          //自动跳转到会员中心
        } else this._alert('很遗憾，您的认证未通过，如有疑问请联系客服')
      }
    },
    created () {
      this.BasicInfo = this.StoreBasicInfo;
      this.certpic = this.BasicInfo.certpic;
    },
    methods: {
       ...mapActions(['POST_RegBuyPersonalFill']),
      /*获取省市区id和name*/
      getCityInfo (info) {
        for (let key in info) {
          this.BasicInfo[key] = info[key]
        }
      },
      /*验证门店基本信息填写是否正确*/
      validateForm () {
        let i = this.BasicInfo
        if (!i.title) return { code: false, msg: '请填写采购商名称' }
        if (!i.province || !i.city || !i.district) return { code: false, msg: '请选择省市区' }
        if (!i.address) return { code: false, msg: '请填写详细地址' }
        if (!this.$GFUN.isFixTel(i.travel_tel)) return { code: false, msg: '请填写正确的办公电话' }

        return { code: true, msg: '表单验证通过' }
      },
      /*保存门店基本信息*/
      async submitForm () {
        // if (!this.$GFUN.powerIsInArray([99,234])) { this._alert('您没有相关权限！',null,'error'); return; }
        let result = this.validateForm()
        if (result.code) {
          this._confirm('确定要保存信息么？',async () => {
            //处理基本信息中的营业执照
            if(this.isAdmin){
              this.$emit('saveInfo', this.BasicInfo)
              return
            }
            // this.BasicInfo.certpic = (await UploadImages(this.certpic))[0];
            this.POST_RegBuyPersonalFill({
              data: this.BasicInfo,
              successFun: () => {
                //跳转会员中心
                 this.$router.push({ name: 'CenterIndex'});
              }})
            // this.$emit('saveInfo', this.BasicInfo);
          })
        } else this._alert(result.msg,null,'error');
      }
    }
  }
</script>
<style scoped>
.btn-login{
  display: block;
  margin: 0 auto;
}
</style>